import "core-js/modules/es.array.is-array.js";
// Duplicated from ab-common
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function arrayEquals(a, b) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  if (!a && !b) return true;
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}
export default arrayEquals;